<template>
  <div>
    <ApplyStep :stepData="stepData" />
    <div class="iv-difficult-apply iv-p-t-24 iv-p-b-40">
      <div class="iv-main-width iv-p-b-40">
        <h1 style="float: left;width: 100%;" class="iv-main-color iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-12">廉洁证明申请</h1>
        <FormLayout
          :readOnly="type == 'viewDetail'"
          ref="FormLayout"
          :model="formItem"
          :list="formList"
          @on-upload-success="onUploadSuccess">
        </FormLayout>
        <LayoutTitle class="iv-m-t-24" title="申请名单" :showBtn="type != 'viewDetail'" btnText="添加人员" @on-click="addPeople">
          <DragTable
            class="iv-m-t-24"
            noSearch
            :showSelect="false"
            ref="DragTable" 
            :immediateForce="true" 
            :columns="columns"
            :showPage="false"
            :showEdit="false"
            :showDelete="false"
            :tableData="tableData">
          </DragTable>
        </LayoutTitle>
        <FooterOperator>
          <div class="iv-text-center">
            <Button v-if="type === 'add'" class="iv-m-r-8" type="submit" @click="onSave">保存</Button>
            <Button v-if="type === 'update'" class="iv-m-r-8" type="submit" @click="onUpdate">修改</Button>
            <Button v-if="type !== 'viewDetail'" class="iv-m-r-8" type="submit" @click="onSubmit">提交申请</Button>
            <Button type="back" @click="onBack">返回</Button>
          </div>
        </FooterOperator>
        <SelectInputMember
          ref="selectInputMember"
          hideSelectInput
          :listProps="listProps"
          @on-change-all="onMemberChange"
        ></SelectInputMember>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
    </div>
  </div>
</template>

<script>
import ApplyStep from '../components/apply-step.vue'
import FormLayout from '@/components/layout/form'
import DragTable from '@/components/drag-table-inline'
import FooterOperator from '@/components/footer-operator'
import SelectInputMember from '@/components/select-input-member'
import allInfo from './allinfo.js'
import columns from './columns.js'
import { timeFormat } from '@/utils'
import LayoutTitle from '@/components/layout/layout-title'

export default {
  name: 'certificationApply',
  data () {
    return {
      spinShow: false,
      stepData: [
        {
          step: 1,
          status: 'ongoing',
          title: '廉洁证明申请'
        },
        {
          step: 2,
          status: 'wait',
          title: '接收申请'
        },
        {
          step: 3,
          status: 'wait',
          title: '开具廉洁证明情况'
        },
        {
          step: 4,
          status: 'wait',
          title: '领导审核'
        },
        {
          step: 5,
          status: 'wait',
          title: '廉洁证明反馈'
        }
      ],
      formList: [],
      formItem: {},
      columns: [],
      tableData: [],
      dictMap: {},
      groupId: '',
      listProps: {
        type: 'checkbox',
        isAllResult: true,
        title: '添加人员'
      },
      chooseList: [],
      type: '',
      fileId: '',
      certificateId: ''
    }
  },
  async created () {
    this.rules = {}
    this.formItem = {
      applyDate: timeFormat(new Date(), 'yyyy-MM-dd'),
      createUserName: sessionStorage.getItem('userName'),
      createUserEmail: sessionStorage.getItem('userEmail'),
      createUserPhone: sessionStorage.getItem('userPhone'),
      createOrgName: sessionStorage.getItem('orgName')
    }
    this.type = this.$decode(this.$route.query.type)
    this.certificateId = this.$decode(this.$route.query.certificateId)
    if (this.type == 'viewDetail' || this.type == 'update') {
      this.getCertificate()
      this.getCertificateUser()
    }
    await this.getCodeTable('KZ41') // 是否需盖纪委章
    this.getCodeTable('DM14') // 性别
    this.getCodeTable('GB4762') // 政治面貌
    this.getCodeTable('DM16') // 学历
    this.getCodeTable('KZ27') // 行政职务
    this.formList = allInfo.call(this)
    this.columns = columns.call(this)
    if (this.type === 'viewDetail') {
      this.columns.pop()
    }
  },
  provide () {
    return {
      expandParent: this.expandParent
    }
  },
  methods: {
    // 添加人员
    addPeople () {
      this.$methods('selectInputMember', 'onShowTree')
    },
    // 从行政树选人
    onMemberChange (list) {
      this.chooseList = list
      this.chooseList.map(item => {
        this.tableData.push({
          userName: item.userName,
          userCode: item.userCode,
          gender: item.gender,
          political: item.political,
          education: item.education,
          workPlace: item.expandFieldax,
          hrDuty: item.hrDuty
        })
      })
      this.$methods('selectInputMember', 'hidedenModal')
    },
    // 查看廉洁证明详情
    getCertificate () {
      this.spinShow = true
      this.$ajax({
        url: 'api-platform/honest/certificate/get',
        method: 'GET',
        data: {
          certificateId: this.certificateId
        }
      }).then(({data}) => {
        this.formItem = data.data
        this.formItem.applyDate = timeFormat(this.formItem.applyDate, 'yyyy-MM-dd')
        // 廉洁无问题证明文件模板
        if (this.formItem.fileId) {
          this.fileId = this.formItem.fileId
          this.getActivityFiles(this.fileId).then(data => {
            this.$set(this.formItem, 'fileId', data)
          })
        } else {
          this.fileId = this.getUuid()
        }
        this.spinShow = false
      })
    },
    // 查看廉洁证明名单详情
    getCertificateUser () {
      this.spinShow = true
      this.$ajax({
        url: 'api-platform/honest/certificate/getCertificateUserList',
        method: 'GET',
        data: {
          certificateId: this.certificateId
        }
      }).then(({data}) => {
        this.tableData = data.data
        this.spinShow = false
      })
    },
    // 保存
    onSave () {
      this.spinShow = true
      this.$ajax({
        url: 'api-platform/honest/certificate/add',
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        disabledData: true,
        data: {
          ...this.formItem,
          certificateUserList: this.tableData
        }
      }).then(({data}) => {
        this.$Message.success('保存成功')
        this.spinShow = false
        this.$router.go(-1)
      })
    },
    // 提交申请
    onSubmit () {
      this.$refs.FormLayout.validate((validate) => {
        if (!validate) return this.$Message.error('有必填项未填写！')
        this.formItem.applyDate = timeFormat(this.formItem.applyDate, 'yyyy-MM-dd')
        // 申请类型：开具个人廉洁证明、特殊事项廉洁证明。当选择“特殊事项廉洁证明”后，需上传证明材料附件。
        if (this.formItem.applyType === 'F2' && !this.formItem.certificateFile) {
          return this.$Message.error('需上传证明文件模板！')
        }
        this.spinShow = true
        this.$ajax({
          url: 'api-platform/honest/certificate/submit',
          method: 'PUT',
          headers: {
            'content-type': 'application/json'
          },
          disabledData: true,
          data: {
            ...this.formItem,
            certificateUserList: this.tableData
          }
        }).then(({data}) => {
          this.$Message.success('提交成功')
          this.spinShow = false
          this.$router.go(-1)
        })
      })
    },
    // 修改
    onUpdate () {
      this.$refs.FormLayout.validate((validate) => {
        if (!validate) return this.$Message.error('有必填项未填写！')
        this.formItem.applyDate = timeFormat(this.formItem.applyDate, 'yyyy-MM-dd')
        this.spinShow = true
        this.$ajax({
          url: 'api-platform/honest/certificate/update',
          method: 'PUT',
          headers: {
            'content-type': 'application/json'
          },
          disabledData: true,
          data: {
            certificateId: this.certificateId,
            ...this.formItem,
            certificateUserList: this.tableData
          }
        }).then(({data}) => {
          this.$Message.success('修改成功')
          this.spinShow = false
          this.$router.go(-1)
        })
      })
    },
    // 删除申请人
    deleteCertificateUser (item) {
      this.$ajax({
        url: 'api-platform/honest/certificate/apply/delete',
        method: 'DELETE',
        data: {
          certificateId: item.certificateId,
          certificateUserIds: item.certificateUserId
        }
      }).then(({data}) => {
        this.$Message.success('删除成功')
        this.getCertificateUser()
        this.spinShow = false
      })
    },
    // 返回
    onBack () {
      this.$router.go(-1)
    },
    onUploadSuccess (res) {
      const file = res.response.data
      this.formItem.fileId = file.fileId
      this.formItem.fileName = file.fileName
      this.$Message.success('上传成功')
    },
    expandParent (type, item) { // 表格行点击
      switch (type) {
        case 'delete': // 删除
          if (this.type == 'update') {
            this.deleteCertificateUser(item)
          } else {
            this.tableData.splice(item._index, 1)
          }
          break
        default:
          break
      }
    },
    // 获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    },
    // 获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
  },
  components: {
    ApplyStep,
    LayoutTitle,
    FormLayout,
    DragTable,
    FooterOperator,
    SelectInputMember
  }
}
</script>
